import { render } from "./Wifi.vue?vue&type=template&id=4cf84f66"
import script from "./Wifi.vue?vue&type=script&lang=js"
export * from "./Wifi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__